function Productos() {
  return (
    <div>
      <h1>Productos</h1>
      <p>Aquí irá la gestión de productos</p>
    </div>
  );
}

export default Productos;